module.exports = __webpack_public_path__ + "img/gente_resolve_bco_vert.d3738f8b.png";